import gql from 'graphql-tag'
import { CART_MUTATION_RESULT } from './fragments.graphql'

export const UPDATE_CART = gql`
  ${CART_MUTATION_RESULT}

  mutation UpdateCart(
    $productErpIdentifier: String!
    $mainProductErpIdentifier: String
    $quantity: Int!
    $comment: String
    $withRequiredEndUserInformation: Boolean = false
    $parentCartItemId: Int
  ) {
    updateCartWithProduct(
      quantity: $quantity
      productErpIdentifier: $productErpIdentifier
      mainProductErpIdentifier: $mainProductErpIdentifier
      comment: $comment
      parentCartItemId: $parentCartItemId
    ) {
      ...CartItemResult
    }
  }
`
